import React from 'react';
import { FormControlLabel, Switch, Box } from '@mui/material';

export default function JailbreakDetectionSwitch({
  value,
  onChange,
  disabled = false,
}) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={Boolean(value)}
            onChange={(e) => onChange(e.target.checked)}
            name='jailbreak_detection'
            disabled={disabled}
          />
        }
        label='Jailbreak Detection'
      />
    </Box>
  );
}
